import {IPosition} from './bus_stop';

export enum BusPositionSource {
  gps = 'GPS',
  ura = 'URA',
  stwbs = 'STWBS',
}

export interface IBusPosition {
  id: string;
  position: IPosition;
  timestamp: Date;
  source: BusPositionSource;
  line?: string;
  metadata?: any;
  journeyRef?: string;
  operationDate?: string;
  lineDestination?: string;
  delay?: number;
  nextStopId?: string;
}



// WEBPACK FOOTER //
// ./src/interfaces/stadtbus/bus_position.ts